 <template>
  <v-app class="custom_bg">
    <v-container>
      <v-row>
        <v-col cols="12" md="12">
          <div class="d-flex align-center justify-center flex-wrap">
            <h2 class="mx-4">Welcome {{ getUser.name }} 👋</h2>
            <v-spacer></v-spacer>

            <v-alert
              v-model="alert"
              dismissible
              color="primary"
              border="left"
              colored-border
              icon="mdi-youtube"
            >
              App setup guide
              <a
                href="https://youtube.com/playlist?list=PL_KudTMUsHMmdNTEgCmjrEEOZHMflHE5Z"
                class="text-capitalize"
                style="text-decoration: none"
                ><v-btn small outlined>click here to watch</v-btn></a
              >
            </v-alert>
          </div>
        </v-col>
        <v-col cols="12" md="12">
          <v-card>
            <v-card-text>
              <v-row>
                <v-col cols="6" md="3">
                  <v-card
                    height="100"
                    outlined
                    class="custom_card"
                    to="/viewSale"
                  >
                    <v-card-text class="px-1">
                      <v-list-item class="px-0">
                        <v-list-item-avatar tile>
                          <v-avatar size="100" color="#EEEEEE" tile>
                            <v-icon color="primary">mdi-chart-bar</v-icon>
                          </v-avatar>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title class="title">
                            {{ sales.length }}
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            Total Sales
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="6" md="3">
                  <v-card
                    height="100"
                    outlined
                    class="custom_card"
                    to="/product"
                  >
                    <v-card-text class="px-1">
                      <v-list-item class="px-0">
                        <v-list-item-avatar tile>
                          <v-avatar size="100" color="#EEEEEE" tile>
                            <v-icon color="primary">mdi-chart-box</v-icon>
                          </v-avatar>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title class="title">
                            {{ product.length }}
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            Total Products
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="6" md="3">
                  <v-card
                    height="100"
                    outlined
                    class="custom_card"
                    to="/customers"
                  >
                    <v-card-text class="px-1">
                      <v-list-item class="px-0">
                        <v-list-item-avatar tile>
                          <v-avatar size="100" color="#EEEEEE" tile>
                            <v-icon color="primary">mdi-chart-pie</v-icon>
                          </v-avatar>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title class="title">
                            {{ getCustomers.length }}
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            Total Customers
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="6" md="3">
                  <v-card
                    height="100"
                    outlined
                    class="custom_card"
                  >
                    <v-card-text class="px-1">
                      <v-list-item class="px-0">
                        <v-list-item-avatar tile>
                          <v-avatar size="100" color="#EEEEEE" tile>
                            <v-icon color="primary">mdi-home-analytics</v-icon>
                          </v-avatar>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title class="title">
                            {{ staffs.length }}
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            Total Staffs
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="8">
          <v-card>
            <v-card-title class="">
              <span>Products</span>
              <v-spacer></v-spacer>
              <v-btn color="primary" small to="/product">see all</v-btn>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="product"
              :items-per-page="6"
              hide-default-footer
              :loading="loading3"
              loading-text="Fetching Products please wait"
            >
              <template v-slot:no-data>
                <span>No data available</span>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
        <v-col cols="12" md="4">
          <v-card>
            <v-card-title class="">
              <span>Transactions</span>
              <v-spacer></v-spacer>
              <v-btn color="primary" small to="/viewSale">see all</v-btn>
            </v-card-title>
            <v-data-table
              :headers="header"
              :items="sales"
              :items-per-page="6"
              hide-default-footer
              loading-text="fetching sales"
              :loading="loading3"
            >
              <template v-slot:[`item.customer`]="{ item }">
                <span>
                  {{ item.customer }}
                </span>
                <span v-if="item.customer == undefined"> Guest </span>
              </template>
              <template v-slot:[`item.created_at`]="{ item }">
                <span>{{
                  new Date(item.created_at).toLocaleDateString()
                }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Home",

  components: {},
  data: () => ({
    alert: true,
    items: [
      {
        name: "Sales",
        color: "primary",
        len: "",
      },
      {
        name: "Products",
        color: "blue",
      },
      {
        name: "Customers",
        color: "green",
      },

      {
        name: "Staffs",
        color: "purple",
      },
    ],

    loading3: false,

    sales: [],
    header: [
      {
        text: "Customer",
        align: "start",
        sortable: false,
        value: "customer",
        class: "grey lighten-4",
      },

      {
        text: " Date",
        value: "created_at",
        sortable: false,
        class: "grey lighten-4",
      },
    ],

    headers: [
      {
        text: "Product Name",
        align: "start",
        sortable: false,
        value: "name",
        class: "grey lighten-4",
      },
      {
        text: "Unit Price",
        value: "price",
        sortable: false,
        class: "grey lighten-4",
      },
      {
        text: "Product Type",
        value: "type",
        sortable: false,
        class: "grey lighten-4",
      },
      {
        text: "Quantity",
        value: "stock",
        sortable: false,
        class: "grey lighten-4",
      },
    ],
    product: [],
    staffs: [],
  }),

  methods: {
    customers() {
      this.$store.dispatch("fetchCustomers");
    },
    fetchProduct() {
      this.loading3 = true;
      fetch(
        "https://receipt.drecsoft.com/api/v1/inventory/fetch-product?pagination=false",

        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.currentUser}`,
          },
        }
      )
        .then((response) => response.json())
        .then((response) => {
          this.loading3 = false;
          this.product = response.data.product;

          console.log(response.data);
        })

        .catch((err) => {
          this.loading3 = false;
          console.log(err);
        });
    },

    fetchSales() {
      this.loading3 = true;
      fetch(
        "https://receipt.drecsoft.com/api/v1/sales/sales?page=1?pagination=false",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.currentUser}`,
          },
        }
      )
        .then((response) => response.json())
        .then((response) => {
          let doc = response.data.sales.data;

          doc.forEach((element) => {
            let data = {
              amount_paid: element.amount_paid,
              created_at: element.created_at,
              customer: element.customer?.name,
              discount: element.discount,
              expected_date: element.expected_date,
              id: element.id,
              order_id: element.order_id,
              payment_method: element.payment_method,
              staff: element.staff,
              status: element.status,
              store_id: element.store_id,
              total_amount: element.total_amount,
              updated_at: element.updated_at,
              user_id: element.user_id,
            };
            this.sales.push(data);
          });
          this.loading3 = false;
          let d = response.data.sales.data;
          console.log(d);
        })

        .catch((err) => {
          this.loading3 = false;
          console.log(err);
        });
    },
    fetchStaffs() {
      this.loading3 = true;
      fetch("https://receipt.drecsoft.com/api/v1/business/all-staff", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.currentUser}`,
        },
      })
        .then((response) => response.json())
        .then((response) => {
          this.staffs = response.staffs;
          this.loading3 = false;
          console.log(response.staffs);
        })

        .catch((err) => {
          this.loading = false;
          console.log(err);
          this.loading3 = false;
        });
    },
  },

  mounted() {
    this.fetchProduct();
    this.fetchSales();
    this.customers();
    this.fetchStaffs();
  },

  computed: {
    ...mapGetters(["getUser", "currentUser", "getCustomers"]),
    pl() {
      return this.product.length;
    },
  },
};
</script>

<style  scoped>
.custom_bg {
  background: #f6f7ff;
}

.custom_card {
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
}
</style>
